export default __webpack_public_path__ + "static/poll-attacks-9c35ec4fef00db6e23b8f967bda9754c.jpg";